import { useQuery } from "@tanstack/react-query";
import { getGoogleLocationMappings } from "../../api/bReviewsApi";

export const useGetGoogleLocationMappings = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["google-location-mappings", organisationId],
    queryFn: () => getGoogleLocationMappings(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
